
import { defineComponent } from 'vue'
import AppMonthYearSelector from '@/components/common/ui/AppMonthYearSelector.vue'
import { ACTION_BACKGROUND_JOB } from '@/store/actions'
import { DatetimeUtils } from '@/utils/datetime'

export default defineComponent({
  name: 'FilterPanel',
  components: {
    AppMonthYearSelector,
  },
  props: {
    appId: {
      type: String,
      required: true,
    },
    isTestMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedLogType: 'popup_displayclick',
      selectedMonthYear: '',
      logTypes: [
        { label: this.$t('label.log_report.popup_click_log_type'), value: 'popup_displayclick' },
        { label: this.$t('label.log_report.popup_cv_log_type'), value: 'popup_cv' },
        { label: this.$t('label.log_report.tracking_id_log_type'), value: 'tracking_id' },
      ],
    }
  },
  methods: {
    onAddReport() {
      const monthYear = this.selectedMonthYear.split('-')
      const fromTime = new Date(Number(monthYear[0]), Number(monthYear[1]) - 1, 1)
      this.$store.dispatch(ACTION_BACKGROUND_JOB.ADD_ITEM, {
        app_id: this.appId,
        type: 'export_tracking_log',
        is_test_mode: this.isTestMode,
        args: {
          app_id: this.appId,
          month_year: this.selectedMonthYear,
          from_time: DatetimeUtils.formatDate(fromTime, 'YYYY-MM-DD HH:mm:ss'),
          to_time: DatetimeUtils.formatDate(DatetimeUtils.endMonth(fromTime), 'YYYY-MM-DD HH:mm:ss'),
          log_type: this.selectedLogType,
          is_test_mode: this.isTestMode,
        },
      })
    },
  },
})
